export const RESUME_ALLOWED_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const RESUME_ALLOWED_EXTENSIONS = [".pdf", ".docx"];

export const RESUME_FILE_CONFIG = {
  allowedTypes: RESUME_ALLOWED_TYPES,
  maxFileSize: 64 * 1024 * 1024, // 64MB
  acceptedExtensions: RESUME_ALLOWED_EXTENSIONS,
};

export const PROCESSED_STATUSES = ["done", "error"];
